export type AllowReadonly<T extends any[]> = T | readonly T[number][]

export type DeepReadonly<T> = {
  readonly [P in keyof T]: DeepReadonly<T[P]>
}

// Returns same value as passed in, but removes readonly from TypeScript type modifier from an array
export const removeReadonly = <T extends any>(arr: T[] | readonly T[]): T[] => arr as T[]

type Writeable<T> = { -readonly [P in keyof T]: T[P] }
type DeepWriteable<T> = { -readonly [P in keyof T]: DeepWriteable<T[P]> }
// Returns same value as passed in, but deep-removes readonly from TypeScript type modifier from object properties
export const removeReadonlyDeep = <T>(val: T): DeepWriteable<T> => val as any
